import React, {Component} from 'react';
import {createMuiTheme, MuiThemeProvider} from '@material-ui/core/styles';
import MomentUtils from '@date-io/moment';
import {MuiPickersUtilsProvider} from 'material-ui-pickers';
import {Redirect, Route, Switch} from 'react-router-dom';
import {connect} from 'react-redux';
import {IntlProvider} from 'react-intl'
import 'react-big-calendar/lib/less/styles.less';
import 'styles/bootstrap.scss'
import 'styles/app.scss';
import 'styles/app-rtl.scss';
import defaultTheme from './themes/defaultTheme';
import AppLocale from '../lngProvider';

import MainApp from 'app/index';
import SignIn from './SignIn';
import SignUp from './SignUp';
import ArmyMap from './ArmyMap/index.js';
import ShareLocationPaxel from './ShareLocationPaxel/index.js';
import ShareLocationJNT from './ShareLocationJ&T/index.js';
import EmbeddMapMonitoring from './EmbeddMapMonitoring/index.js';
import EmbeddMapMonitoringV2 from '../app/routes/EmbeddMapMonitoringV2/index.js';
import EmbeddViewMonitoringDispatch from '../app/routes/EmbeddViewMonitoringDispatch/index.js';
import EmbeddTrackingMonitoring from './EmbeddTrackingMonitoring/index.js';
import {setInitUrl} from '../actions/Auth';
import RTL from 'util/RTL';
import asyncComponent from 'util/asyncComponent';
import ForgotPassword from './ForgotPassword';
import EmbeddGanttMonitoring from '../app/routes/EmbeddGanttMonitoring';


const packageName = localStorage.getItem('package')

const RestrictedRoute = ({component: Component, authUser, ...rest}) =>
    <Route
        {...rest}
        render={props =>
            authUser
                ? <Component {...props} />
                : <Redirect
                    to={{
                        pathname: '/signin',
                        state: {from: props.location}
                    }}
                />}
    />;

class App extends Component {

    render() {
        const {match, location, locale, authUser, initURL, isDirectionRTL} = this.props;
        if (location.pathname === '/') {
            if (authUser === null) {
                return ( <Redirect to={'/signin'}/> );
            } else if (initURL === '' || initURL === '/' || initURL === '/signin') {
                if(packageName === 'Lite'){
                    return ( <Redirect to={'/app/dashboard-lite'}/> );
                } else {
                    return ( <Redirect to={'/app/dashboard-vehicle'}/> );
                    // return ( <Redirect to={{ 
                    //     pathname: '/app/attach',
                    //     search: '?name=map',
                    // }}/> );
                }
            } else {
                return ( <Redirect to={initURL}/> );
            }
        }
        const applyTheme = createMuiTheme(defaultTheme);

        if (isDirectionRTL) {
            applyTheme.direction = 'rtl';
            document.body.classList.add('rtl')
        } else {
            document.body.classList.remove('rtl');
            applyTheme.direction = 'ltr';
        }

        const currentAppLocale = AppLocale[locale.locale];
        return (
            <MuiThemeProvider theme={applyTheme}>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                    <IntlProvider
                        locale={currentAppLocale.locale}
                        messages={currentAppLocale.messages}>
                        <RTL>
                            <div className="app-main">
                                <Switch>
                                    <RestrictedRoute path={`${match.url}app`} authUser={authUser}
                                                    component={MainApp}/>
                                    <Route path='/signin' component={SignIn}/>
                                    <Route path='/signup' component={SignUp}/>
                                    <Route path='/forgot-password' component={ForgotPassword}/>
                                    <Route path='/army-map' component={ArmyMap}/>
                                    <Route path='/share-location/paxel' component={ShareLocationPaxel}/>
                                    <Route path='/share-location/jnt' component={ShareLocationJNT}/>
                                    <Route path='/embedd/tracking-monitoring' component={EmbeddTrackingMonitoring}/>
                                    <Route path='/embedd/tracking/mapMonitoring' component={EmbeddMapMonitoring}/>
                                    <Route path='/maps-monitoring' component={EmbeddMapMonitoringV2}/>
                                    <Route path='/view-monitoring-dispatch' component={EmbeddViewMonitoringDispatch}/>
                                    <Route path='/gantt-monitoring' component={EmbeddGanttMonitoring}/>
                                    <Route
                                        component={asyncComponent(() => import('components/Error404'))}/>
                                </Switch>
                            </div>
                        </RTL>
                    </IntlProvider>
                </MuiPickersUtilsProvider>
            </MuiThemeProvider>
        );
    }
}

const mapStateToProps = ({settings, auth}) => {
    const {sideNavColor, locale, isDirectionRTL} = settings;
    const {authUser, initURL} = auth;
    return {sideNavColor, locale, isDirectionRTL, authUser, initURL}
};

export default connect(mapStateToProps, {setInitUrl})(App);




// WEBPACK FOOTER //
// ./containers/App.js